const getters = {
  user: state => state.user,
  token: state => state.user.token,
  apply_state: state => state.dict.apply_state,
  apply_type: state => state.dict.apply_state,
  orm_type: state => state.dict.orm_type,
  store_type: state => state.dict.store_type,
  area: state => state.dict.area,
  store_level: state => state.dict.store_level,
  device_type: state => state.dict.device_type,
  order_source: state => state.dict.order_source,
  withdraw_state: state => state.dict.withdraw_state,
  device_category: state => state.dict.device_category,
  device_supplier: state => state.dict.device_supplier,
  cs_type: state => state.dict.cs_type,
  bs_type: state => state.dict.bs_type,
  order_state: state => state.dict.order_state, 
  feed_back: state => state.dict.feed_back, 
  order_search_time: state => state.dict.order_search_time,
  sys_config: state => state.dict.sys_config, 
}

export default getters



// WEBPACK FOOTER //
// ./src/store/getter.js